import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Divider, RaisedButton, Card, CardHeader, CardText, TextField, DatePicker, Checkbox,
  List, ListItem, RadioButton, RadioButtonGroup
} from "material-ui";
import DateIcon from "material-ui/svg-icons/action/date-range";
import customDateTimeFormat from "../../../helpers/dateFormat";
import {
  CambiarComentario, CambiarValorReajuste, CambiarValorReajusteMax,
  CambiarCheckCentroAtencion, CambiarCheckTipoPrestacion, CambiarCheckArancel,
  CheckCentroAtencionTodos, CheckTipoPrestacionTodos, CheckArancelTodos, ModalSolicitudReajustePaso,
  CambiarValorReajusteError, CambiarCheckCentroAtencionError,
  CambiarCheckTipoPrestacionError, CambiarCheckArancelError, CargarCombinacionesSolicitudReajuste, PermiteReplicarSolicitud,
  CambiarValorReajusteErrorPQ, CambiarValorReajustePQ, CambiarComentarioPQ, CheckCentroAtencionTodosPQ,
  CambiarCheckCentroAtencionErrorPQ, CambiarCheckCentroAtencionPQ, CambiarVigenciaReajuste, CambiarVigenciaReajustePQ,
  ObtenerVigenciasPaquetes, CambiarVigenciasErrorPQ, CheckVigenciaPaquete, CambiarCheckVigenciaPaqueteError,
  CheckVigenciaPaqueteTodos, CambiarInicioReajusteError, CambiarInicioReajustePQError, CambiarReplicaPaquetes,
  CambiarReplicaPQError, CambiarReplicaArancelError, CambiarReplicaArancel, CargarCombinacionesSolicitudReajustePQ,
  CambiarValorReajusteMaxPQ
} from "./actions";
import { ObtenerCentrosAtencion, ObtenerTiposArancelAll, ObtenerTiposPrestaciones } from "../../Global/actions";
import HistorialReajustes from "../HistorialReajustes/view";
import banmedicaTheme from "./../../../config/banmedicaTheme";
import styles from "../../styles/styles";
import { Loading } from "../FiltroBusqueda/actions";

class SolicitudReajuste extends React.Component {
  componentWillMount() {
    this.props.dispatch(ObtenerVigenciasPaquetes());
    this.props.dispatch(ObtenerCentrosAtencion());
    this.props.dispatch(ObtenerTiposArancelAll());
    this.props.dispatch(ObtenerTiposPrestaciones());
    const valorR = (this.props.periodoReajuste.ValorReajuste || 1).toString().replace(".", ",");
    const valorRPQ = (this.props.periodoReajustePQ.ValorReajuste || 1).toString().replace(".", ",");
    this.props.dispatch(CambiarValorReajuste(valorR));
    this.props.dispatch(CambiarValorReajustePQ(valorRPQ));
    this.props.dispatch(CambiarValorReajusteMax(this.props.periodoReajuste.ValorReajuste || 1));
    this.props.dispatch(CambiarValorReajusteMaxPQ(this.props.periodoReajustePQ.ValorReajuste || 1));
    this.props.dispatch(PermiteReplicarSolicitud());
  }

  CambiarValorReajustePaquetes = (event) => {
    const re = /^[0-9]{1,4}(,[0-9]{0,5})?$/;
    let valorR = event.target.value;
    if (event.target.value === "" || re.test(event.target.value)) {
      if (valorR.indexOf(',') > -1) {
        valorR = valorR.replace(",", ".");
      }
      if (this.props.valorReajusteMaxPQ >= parseFloat(valorR)) {
        this.props.dispatch(CambiarValorReajusteErrorPQ(""));
        this.props.dispatch(CambiarValorReajustePQ(event.target.value.toString()));
      } else if (this.props.valorReajusteMaxPQ < parseFloat(valorR)) {
        this.props.dispatch(CambiarValorReajusteErrorPQ(`Indicar un valor de recargo válido menor o igual a ${this.props.valorReajusteMaxPQ.toString().replace(".", ",")}`));
        this.props.dispatch(CambiarValorReajustePQ(event.target.value.toString()));
      } else {
        this.props.dispatch(CambiarValorReajusteErrorPQ(""));
        this.props.dispatch(CambiarValorReajustePQ(event.target.value));
      }
    }
  }

  CambiarValorReajuste = (event) => {
    const re = /^[0-9]{1,4}(,[0-9]{0,5})?$/;
    let valorR = event.target.value;
    if (event.target.value === "" || re.test(event.target.value)) {
      if (valorR.indexOf(',') > -1) {
        valorR = valorR.replace(",", ".");
      }
      if (this.props.valorReajusteMax >= parseFloat(valorR)) {
        this.props.dispatch(CambiarValorReajusteError(""));
        this.props.dispatch(CambiarValorReajuste(event.target.value.toString()));
      } else if (this.props.valorReajusteMax < parseFloat(valorR)) {
        this.props.dispatch(CambiarValorReajusteError(`Indicar un valor de recargo válido menor o igual a ${this.props.valorReajusteMax.toString().replace(".", ",")}`));
        this.props.dispatch(CambiarValorReajuste(event.target.value.toString()));
      } else {
        this.props.dispatch(CambiarValorReajusteError(""));
        this.props.dispatch(CambiarValorReajuste(event.target.value));
      }
    }
  }

  CambiarValorReajusteMax = (event) => {
    this.props.dispatch(CambiarValorReajusteMax(event.target.value));
  }
  CambiarComentario = (event) => {
    this.props.dispatch(CambiarComentario(event.target.value));
  }

  CambiarComentarioPQ = (event) => {
    this.props.dispatch(CambiarComentarioPQ(event.target.value));
  }

  ModalSolicitudReajuste = () => {
    this.props.dispatch(ModalSolicitudReajustePaso(0));
  }

  RealizarSolicitudReajuste = () => {
    let conError = false;

    if (this.props.periodoReajuste.ValidoArancel === 1) {
      let valorR = this.props.valorReajuste;
      if (valorR.indexOf(',') > -1) {
        valorR = valorR.replace(",", ".");
      }
      if (!this.props.valorReajuste) {
        conError = true;
        this.props.dispatch(CambiarValorReajusteError("Indicar valor de reajuste"));
      }
      if (this.props.valorReajusteMax < parseFloat(valorR)) {
        conError = true;
      }
      if (this.props.checkCentrosAtencion.length === 0) {
        this.props.dispatch(CambiarCheckCentroAtencionError(true));
        conError = true;
      }
      if (this.props.checkTiposPrestacion.length === 0) {
        this.props.dispatch(CambiarCheckTipoPrestacionError(true));
        conError = true;
      }
      if (this.props.checkAranceles.length === 0) {
        this.props.dispatch(CambiarCheckArancelError(true));
        conError = true;
      }
      if (this.props.vigenciaReajuste === null) {
        this.props.dispatch(CambiarInicioReajusteError(true));
        conError = true;
      }
      if (this.props.replicaArancel === null) {
        this.props.dispatch(CambiarReplicaArancelError(true));
        conError = true;
      }
    }
    if (this.props.periodoReajustePQ.ValidoPaquetes === 1) {
      let valorRP = this.props.valorReajustePaquetes;
      if (valorRP.indexOf(',') > -1) {
        valorRP = valorRP.replace(",", ".");
      }
      if (!this.props.valorReajustePaquetes) {
        conError = true;
        this.props.dispatch(CambiarValorReajusteErrorPQ("Indicar valor de reajuste"));
      }
      if (this.props.valorReajusteMaxPQ < parseFloat(valorRP)) {
        conError = true;
      }
      if (this.props.checkCentrosAtencionPQ.length === 0) {
        this.props.dispatch(CambiarCheckCentroAtencionErrorPQ(true));
        conError = true;
      }
      if (this.props.checkVigenciasPaquetes.length === 0) {
        this.props.dispatch(CambiarCheckVigenciaPaqueteError(true));
        conError = true;
      }
      if (this.props.vigenciaReajustePQ === null) {
        this.props.dispatch(CambiarInicioReajustePQError(true));
        conError = true;
      }
      if (this.props.replicaPaquetes === null) {
        this.props.dispatch(CambiarReplicaPQError(true));
        conError = true;
      }
    }

    if (!conError) {
      if (this.props.periodoReajuste.ValidoArancel === 1) {
        this.props.dispatch(CargarCombinacionesSolicitudReajuste());
      }
      if (this.props.periodoReajustePQ.ValidoPaquetes === 1) {
        this.props.dispatch(CargarCombinacionesSolicitudReajustePQ());
      }
      this.props.dispatch(ModalSolicitudReajustePaso(2));
      this.props.dispatch(Loading(true));
    }
  }

  ConfirmarSolicitarReajuste = () => {
    this.props.dispatch(ModalSolicitudReajustePaso(2));
  }

  CheckCentroAtencion = (event, isChecked, id) => {
    this.props.dispatch(CambiarCheckCentroAtencion(isChecked, id));
    this.props.dispatch(CambiarCheckCentroAtencionError(false));
  }

  CheckCentroAtencionPQ = (event, isChecked, id) => {
    this.props.dispatch(CambiarCheckCentroAtencionPQ(isChecked, id));
    this.props.dispatch(CambiarCheckCentroAtencionErrorPQ(false));
  }

  CheckTipoPrestacion = (event, isChecked, id) => {
    this.props.dispatch(CambiarCheckTipoPrestacion(isChecked, id));
    this.props.dispatch(CambiarCheckTipoPrestacionError(false));
  }

  CheckArancel = (event, isChecked, id) => {
    this.props.dispatch(CambiarCheckArancel(isChecked, id));
    this.props.dispatch(CambiarCheckArancelError(false));
  }

  CheckVigenciaPaquete = (event, isChecked, id) => {
    this.props.dispatch(CheckVigenciaPaquete(isChecked, id));
    this.props.dispatch(CambiarCheckVigenciaPaqueteError(false));
  }

  CheckCentroAtencionTodos = (event, isChecked) => {
    const arrayTodos = [];
    for (let i = 0; i < this.props.centrosAtencion.length; i += 1) {
      arrayTodos.push(this.props.centrosAtencion[i].Secuencia);
    }
    this.props.dispatch(CheckCentroAtencionTodos(isChecked, arrayTodos));
    this.props.dispatch(CambiarCheckCentroAtencionError(false));
  }

  CheckCentroAtencionTodosPQ = (event, isChecked) => {
    const arrayTodos = [];
    for (let i = 0; i < this.props.tiposArancel.length; i += 1) {
      arrayTodos.push(this.props.tiposArancel[i].Rut);
    }
    this.props.dispatch(CheckCentroAtencionTodosPQ(isChecked, arrayTodos));
    this.props.dispatch(CambiarCheckCentroAtencionErrorPQ(false));
  }

  CheckVigenciaPaqueteTodos = (event, isChecked) => {
    const arrayTodos = [];
    for (let i = 0; i < this.props.vigenciasPaquetes.length; i += 1) {
      arrayTodos.push(this.props.vigenciasPaquetes[i]);
    }
    this.props.dispatch(CheckVigenciaPaqueteTodos(isChecked, arrayTodos));
    this.props.dispatch(CambiarVigenciasErrorPQ(false));
  }

  CheckTipoPrestacionTodos = (event, isChecked) => {
    const arrayTodos = [];
    for (let i = 0; i < this.props.tiposPrestaciones.length; i += 1) {
      if (this.props.tiposPrestaciones[i].Id > 0) {
        arrayTodos.push(this.props.tiposPrestaciones[i].Id);
      }
    }
    this.props.dispatch(CheckTipoPrestacionTodos(isChecked, arrayTodos));
    this.props.dispatch(CambiarCheckTipoPrestacionError(false));
  }

  CheckArancelTodos = (event, isChecked) => {
    const arrayTodos = [];
    for (let i = 0; i < this.props.tiposArancel.length; i += 1) {
      arrayTodos.push(this.props.tiposArancel[i].Rut);
    }
    this.props.dispatch(CheckArancelTodos(isChecked, arrayTodos));
    this.props.dispatch(CambiarCheckArancelError(false));
  }

  CambiarVigenciaReajuste = (event, date) => {
    this.props.dispatch(CambiarVigenciaReajuste(date /* dateMod */));
    this.props.dispatch(CambiarInicioReajusteError(false));
  }

  CambiarVigenciaReajustePQ = (event, date) => {
    this.props.dispatch(CambiarVigenciaReajustePQ(date /* dateMod */));
    this.props.dispatch(CambiarInicioReajustePQError(false));
  }

  CambiarReplicaPaquetes = (event, value) => {
    this.props.dispatch(CambiarReplicaPaquetes(value));
    this.props.dispatch(CambiarReplicaPQError(false));
  }

  CambiarReplicaArancel = (event, value) => {
    this.props.dispatch(CambiarReplicaArancel(value));
    this.props.dispatch(CambiarReplicaArancelError(false));
  }



  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    const menuListCentroAtencion = [];
    if (this.props.centrosAtencion) {
      this.props.centrosAtencion.forEach((element, index) => {
        menuListCentroAtencion.push((
          <ListItem
            key={index}
            primaryText={element.Descripcion}
            leftCheckbox={<Checkbox
              checked={this.props.checkCentrosAtencion.includes(element.Secuencia)}
              onCheck={(event, isChecked) => this.CheckCentroAtencion(event, isChecked, element.Secuencia)}
              className="mui-checkbox"
            />}
            className="mui-listitem"
          />
        ));
      });
    }

    const menuListTipoArancelPQ = [];
    if (this.props.tiposArancel) {
      this.props.tiposArancel.forEach((element, index) => {
        menuListTipoArancelPQ.push((
          <ListItem
            key={index}
            primaryText={element.Descripcion}
            leftCheckbox={<Checkbox
              checked={this.props.checkCentrosAtencionPQ.includes(element.Rut)}
              onCheck={(event, isChecked) => this.CheckCentroAtencionPQ(event, isChecked, element.Rut)}
              className="mui-checkbox"
            />}
            className="mui-listitem"
          />
        ));
      });
    }

    const menuListTiposPrestaciones = [];
    if (this.props.tiposPrestaciones) {
      this.props.tiposPrestaciones.forEach((element, index) => {
        if (element.Id.toString() !== "0") {
          menuListTiposPrestaciones.push((
            <ListItem
              key={index}
              primaryText={`${element.TipoAtencion}: ${element.Descripcion}`}
              leftCheckbox={<Checkbox
                checked={this.props.checkTiposPrestacion.includes(element.Id)}
                onCheck={(event, isChecked) => this.CheckTipoPrestacion(event, isChecked, element.Id)}
                className="mui-checkbox"
              />}
              className="mui-listitem"
            />
          ));
        }
      });
    }

    const menuListTipoArancel = [];
    if (this.props.tiposArancel) {
      this.props.tiposArancel.forEach((element, index) => {
        menuListTipoArancel.push((
          <ListItem
            key={index}
            primaryText={element.Descripcion}
            leftCheckbox={<Checkbox
              checked={this.props.checkAranceles.includes(element.Rut)}
              onCheck={(event, isChecked) => this.CheckArancel(event, isChecked, element.Rut)}
              className="mui-checkbox"
            />}
            className="mui-listitem"
          />
        ));
      });
    }

    const menuListVigenciaPaquetes = [];
    if (this.props.vigenciasPaquetes) {
      this.props.vigenciasPaquetes.forEach((element, index) => {
        menuListVigenciaPaquetes.push((
          <ListItem
            key={index}
            primaryText={element}
            leftCheckbox={<Checkbox
              checked={this.props.checkVigenciasPaquetes.includes(element)}
              onCheck={(event, isChecked) => this.CheckVigenciaPaquete(event, isChecked, element)}
              className="mui-checkbox"
            />}
            className="mui-listitem"
          />
        ));
      });
    }

    /*const menuListPermanenciaFonasa = [];
    if (this.props.pertenenciasFonasa) {
      this.props.pertenenciasFonasa.forEach((element) => {
        menuListPermanenciaFonasa.push(<RadioButton key={element.Simbolo} value={element.Simbolo} label={element.Descripcion} style={styles.customWidth} />);
      });
    }*/

    const isCentroAtencionAll = this.props.checkCentrosAtencion.length === this.props.centrosAtencion.length;
    const isTipoPrestacionAll = this.props.checkTiposPrestacion.length === this.props.tiposPrestaciones.filter((tp) => tp.Id > 0).length;
    const isTIpoArancelAll = this.props.checkAranceles.length === this.props.tiposArancel.length;
    const isCentroAtencionPQAll = this.props.checkCentrosAtencionPQ.length === this.props.tiposArancel.length;
    const isVigenciaPaquetesAll = this.props.checkVigenciasPaquetes.length === this.props.vigenciasPaquetes.length;

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Solicitar Reajuste por IPC
                  </div>
                  <div style={styles.h2}>
                    Este reajuste se realizará sobre todos los grupos de prestación seleccionados.
                    En caso de que desee realizar modificaciones, deberá solicitarlas y luego de tener
                    una resolución de la Isapre, teniendo los valores cargados y actualizados,
                    usted deberá solicitar el reajuste. Lo mismo se aplica para paquetes quirúrgicos.
                  </div>
                  <br></br>
                  <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                  </div>
                </div>
              </div>

              {(this.props.periodoReajuste.ValidoArancel === 1) ?
                <div style={{ padding: "5px" }}>
                  <Card
                    initiallyExpanded
                    zDepth={0}
                  >
                    <CardHeader
                      actAsExpander={false}
                      showExpandableButton
                      iconStyle={{ height: 30, width: 30, color: "#212121" }}
                      style={{
                        paddingTop: "0px", paddingBottom: "0px", maxWidth: "1290px", overflow: "hidden",
                      }}
                    >
                      <div className="row" style={{ paddingBottom: 0 }}>
                        <div className="col-4">
                          <div style={styles.h1}>Reajuste Arancel</div>
                        </div>
                        <div className="col-4"></div>
                        <div className="col-4">
                          <div style={styles.floatingClaseSelect2}>Replicar otra Isapre</div>
                          <RadioButtonGroup
                            name="rd_npf_replica"
                            id="rd_npf_replica"
                            valueSelected={this.props.replicaArancel}
                            onChange={this.CambiarReplicaArancel}
                            style={styles.customWidth}
                          // errorText={this.props.detallePrestacion.pertenenciaFonasaErr || ""}
                          >
                            <RadioButton key={1} value={1} label={"Sí"} style={styles.customWidth} />
                            <RadioButton key={2} value={2} label={"No"} style={styles.customWidth} />
                          </RadioButtonGroup>
                          {this.props.replicaArancelError ?
                            <div style={{ color: "red" }}>Seleccionar una opción</div>
                            : null}
                        </div>
                      </div>
                    </CardHeader>
                    <CardText
                      expandable
                      style={{
                        paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
                      }}
                    >
                      <div className="row" style={{ paddingBottom: 0 }}>
                        <div className="col-4" style={styles.colSelectFieldActualizar}>
                          <div style={styles.floatingClaseSelect}>Valor a Reajustar (%)</div>
                          <TextField
                            name="txt_srra_valorreajuste"
                            id="txt_srra_valorreajuste"
                            value={this.props.valorReajuste}
                            onChange={this.CambiarValorReajuste}
                            maxLength={10}
                            errorText={this.props.valorReajusteError}
                            underlineStyle={styles.underlineSelectField}
                            inputStyle={styles.h4}
                            style={styles.selectFiledStyle}
                            errorStyle={styles.errorStyle}
                          />
                        </div>
                        <div className="col-4" style={styles.colSelectFieldActualizar}>
                          <div style={styles.floatingClaseSelect}>Inicio Vigencia</div>
                          <div className="container">
                            <div className="row" >
                              <DatePicker
                                name="dp_srra_inicioVigencia"
                                id="dp_srra_inicioVigencia"
                                mode="landscape"
                                DateTimeFormat={customDateTimeFormat.cl()}
                                locale="es-CL"
                                firstDayOfWeek={1}
                                value={this.props.vigenciaReajuste}
                                onChange={this.CambiarVigenciaReajuste}
                                underlineStyle={styles.underlineSelectField}
                                style={styles.datepickerStyle}
                                inputStyle={styles.h4}
                                //disabled
                                //errorText={this.props.vigenciaReajusteError}
                                errorStyle={styles.errorStyle}
                                minDate={minDate}
                              />
                              <DateIcon
                                // iconStyle={{ height: 20, width: 20 }}
                                style={{ marginTop: 3, marginLeft: 5 }}
                                color={banmedicaTheme.palette.accent1Color}
                              />
                              {this.props.inicioVigenciaReajusteError ?
                                <div style={{ color: "red" }}>Seleccionar Fecha Inicio Vigencia</div>
                                : null}
                            </div>
                          </div>
                        </div>
                        <div className="col-4" style={styles.colSelectFieldActualizar}>
                          <div style={styles.floatingClaseSelect}>Observaciones</div>
                          <TextField
                            name="txt_srra_comentario"
                            id="txt_srra_comentario"
                            value={this.props.comentario}
                            onChange={this.CambiarComentario}
                            multiLine
                            rows={1}
                            rowsMax={5}
                            underlineStyle={styles.underlineSelectField}
                            inputStyle={styles.h4}
                            style={styles.selectFiledStyle}
                            errorStyle={styles.errorStyle}
                            maxLength={500}
                          />
                        </div>
                      </div>
                      <div className="row" style={{ paddingBottom: 0, marginTop: 10, marginBottom: 20 }}>
                        <div className="col-12" style={{ margin: 0, padding: 0 }}>
                          <div style={styles.h2}>
                            Seleccione el grupo de prestación al que desea solicitar reajustar.
                            Si desea reajustar todo el arancel seleccione &#34;Todos&#34;.
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: 10 }}>
                        <div className="col-4">
                          <Checkbox
                            label="Todos Centros de Atención"
                            checked={isCentroAtencionAll}
                            onCheck={this.CheckCentroAtencionTodos}
                            // style={styles.checkbox}
                            className="mui-checkbox"
                          />
                          {this.props.checkCentrosAtencionError ?
                            <div style={{ color: "red" }}>Seleccionar centro de atención</div>
                            : null}
                          <List style={{ maxHeight: "400px", overflowX: "auto" }}>
                            {menuListCentroAtencion}
                          </List>
                        </div>
                        <div className="col-4" style={{ borderLeft: "2px solid #e0e0e0", borderRight: "2px solid #e0e0e0" }}>
                          <Checkbox
                            label="Todos Tipo de Prestación Isapre"
                            checked={isTipoPrestacionAll}
                            onCheck={this.CheckTipoPrestacionTodos}
                            className="mui-checkbox"
                          />
                          {this.props.checkTiposPrestacionError ?
                            <div style={{ color: "red" }}>Seleccionar tipo de prestación</div>
                            : null}
                          <List style={{ maxHeight: "300px", overflowX: "auto" }}>
                            {menuListTiposPrestaciones}
                          </List>
                        </div>
                        <div className="col-4">
                          <Checkbox
                            label="Todos los Aranceles"
                            checked={isTIpoArancelAll}
                            onCheck={this.CheckArancelTodos}
                            className="mui-checkbox"
                          />
                          {this.props.checkArancelesError ?
                            <div style={{ color: "red" }}>Seleccionar arancel</div>
                            : null}
                          <List style={{ maxHeight: "400px", overflowX: "auto" }}>
                            {menuListTipoArancel}
                          </List>
                        </div>
                      </div>
                      <div className="row" style={{ paddingBottom: 0, marginTop: 10, marginBottom: 10 }}>
                        <div className="col-12" style={{ margin: 0, padding: 0 }}>
                          <div style={styles.h2}>
                            * El reajuste se aplicará a los valores totales cargados en la isapre, señalados anteriormente.
                          </div>
                        </div>
                      </div>
                    </CardText>
                  </Card>
                </div>
                : null}

              {(this.props.periodoReajustePQ.ValidoPaquetes === 1) ?
                <div style={{ padding: "5px" }}>
                  <Card
                    initiallyExpanded
                    zDepth={0}
                  >
                    <CardHeader
                      actAsExpander={false}
                      showExpandableButton
                      iconStyle={{ height: 30, width: 30, color: "#212121" }}
                      style={{
                        paddingTop: "0px", paddingBottom: "0px", maxWidth: "1290px", overflow: "hidden",
                      }}
                    >
                      <div className="row" style={{ paddingBottom: 0 }}>
                        <div className="col-4">
                          <div style={styles.h1}>Reajuste Paquetes</div>
                        </div>
                        <div className="col-4"></div>
                        <div className="col-4">
                          <div style={styles.floatingClaseSelect2}>Replicar otra Isapre</div>
                          <RadioButtonGroup
                            name="rd_npf_replica"
                            id="rd_npf_replica"
                            valueSelected={this.props.replicaPaquetes}
                            onChange={this.CambiarReplicaPaquetes}
                            style={styles.customWidth}
                          // errorText={this.props.detallePrestacion.pertenenciaFonasaErr || ""}
                          >
                            <RadioButton key={1} value={1} label={"Sí"} style={styles.customWidth} />
                            <RadioButton key={2} value={2} label={"No"} style={styles.customWidth} />
                          </RadioButtonGroup>
                          {this.props.replicaPaquetesError ?
                            <div style={{ color: "red" }}>Seleccionar una opción</div>
                            : null}
                        </div>
                      </div>
                    </CardHeader>
                    <CardText
                      expandable
                      style={{
                        paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
                      }}
                    >
                      <div className="row" style={{ paddingBottom: 0 }}>
                        <div className="col-4" style={styles.colSelectFieldActualizar}>
                          <div style={styles.floatingClaseSelect}>Valor a Reajustar (%)</div>
                          <TextField
                            name="txt_srra_valorreajustePaquetes"
                            id="txt_srra_valorreajustePaquetes"
                            value={this.props.valorReajustePaquetes}
                            onChange={this.CambiarValorReajustePaquetes}
                            maxLength={10}
                            errorText={this.props.valorReajustePaquetesError}
                            underlineStyle={styles.underlineSelectField}
                            inputStyle={styles.h4}
                            style={styles.selectFiledStyle}
                            errorStyle={styles.errorStyle}
                          />
                        </div>
                        <div className="col-4" style={styles.colSelectFieldActualizar}>
                          <div style={styles.floatingClaseSelect}>Inicio Vigencia</div>
                          <div className="container">
                            <div className="row" >
                              <DatePicker
                                name="dp_srra_inicioVigenciaPQ"
                                id="dp_srra_inicioVigenciaPQ"
                                mode="landscape"
                                DateTimeFormat={customDateTimeFormat.cl()}
                                locale="es-CL"
                                firstDayOfWeek={1}
                                value={this.props.vigenciaReajustePQ}
                                onChange={this.CambiarVigenciaReajustePQ}
                                underlineStyle={styles.underlineSelectField}
                                style={styles.datepickerStyle}
                                inputStyle={styles.h4}
                                //disabled
                                //errorText={this.props.vigenciaReajustePQError}
                                errorStyle={styles.errorStyle}
                                minDate={minDate}
                              />
                              <DateIcon
                                // iconStyle={{ height: 20, width: 20 }}
                                style={{ marginTop: 3, marginLeft: 5 }}
                                color={banmedicaTheme.palette.accent1Color}
                              />
                              {this.props.inicioVigenciaReajustePQError ?
                                <div style={{ color: "red" }}>Seleccionar Fecha Inicio Vigencia</div>
                                : null}
                            </div>
                          </div>
                        </div>
                        <div className="col-4" style={styles.colSelectFieldActualizar}>
                          <div style={styles.floatingClaseSelect}>Observaciones</div>
                          <TextField
                            name="txt_srra_comentario"
                            id="txt_srra_comentario"
                            value={this.props.comentarioPQ}
                            onChange={this.CambiarComentarioPQ}
                            multiLine
                            rows={1}
                            rowsMax={5}
                            underlineStyle={styles.underlineSelectField}
                            inputStyle={styles.h4}
                            style={styles.selectFiledStyle}
                            errorStyle={styles.errorStyle}
                            maxLength={500}
                          />
                        </div>
                      </div>
                      <div className="row" style={{ paddingBottom: 0, marginTop: 10, marginBottom: 20 }}>
                        <div className="col-12" style={{ margin: 0, padding: 0 }}>
                          <div style={styles.h2}>
                            Seleccione la vigencia que quiere reajustar.
                            Si desea reajustar todas seleccione la opción &#34;Todos&#34;.
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: 10 }}>
                        <div className="col-4">
                          <Checkbox
                            label="Todos los Aranceles"
                            checked={isCentroAtencionPQAll}
                            onCheck={this.CheckCentroAtencionTodosPQ}
                            // style={styles.checkbox}
                            className="mui-checkbox"
                          />
                          {this.props.checkCentrosAtencionErrorPQ ?
                            <div style={{ color: "red" }}>Seleccionar arancel</div>
                            : null}
                          <List style={{ maxHeight: "400px", overflowX: "auto" }}>
                            {menuListTipoArancelPQ}
                          </List>
                        </div>
                        <div className="col-4" style={{ borderLeft: "2px solid #e0e0e0", borderRight: "2px solid #e0e0e0" }}>
                          <Checkbox
                            label="Todas las Vigencias actuales"
                            checked={isVigenciaPaquetesAll}
                            onCheck={this.CheckVigenciaPaqueteTodos}
                            className="mui-checkbox"
                          />
                          {this.props.checkVigenciasErrorPQ ?
                            <div style={{ color: "red" }}>Seleccionar vigencia</div>
                            : null}
                          <List style={{ maxHeight: "300px", overflowX: "auto" }}>
                            {menuListVigenciaPaquetes}
                          </List>
                        </div>
                      </div>
                      <div className="row" style={{ paddingBottom: 0, marginTop: 10, marginBottom: 10 }}>
                        <div className="col-12" style={{ margin: 0, padding: 0 }}>
                          <div style={styles.h2}>
                            * El reajuste se aplicará a los valores totales cargados en la isapre, señalados anteriormente.
                          </div>
                        </div>
                      </div>
                    </CardText>
                  </Card>
                </div>
                : null}

              <div className="row">
                <div className="col-6" style={{ textAlign: "left", marginTop: 10, marginBottom: 10 }}>
                  <RaisedButton
                    label="Volver atrás"
                    onClick={this.ModalSolicitudReajuste}
                    icon={<i className="material-icons">keyboard_arrow_left</i>}
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />
                </div>
                <div className="col-6" style={{ textAlign: "right", marginTop: 10, marginBottom: 10 }}>
                  {!this.props.loading ?
                    <RaisedButton
                      label="Solicitar Reajuste"
                      onClick={this.RealizarSolicitudReajuste}
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      //style={{ width: "145px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                    :
                    <RaisedButton
                      label="Cargando ..."
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                  }
                </div>
              </div>

            </CardText>
          </Card>
        </div>
        {/* <div className="row">
          <div className="col-12" style={{ padding: 0, margin: 0 }}>
            <Divider style={{ marginTop: 10, marginBottom: 10 }} />
          </div>
        </div>
        <HistorialReajustes /> */}

      </div>
    );
  }
}

SolicitudReajuste.propTypes = {
  loading: PropTypes.bool.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  valorReajuste: PropTypes.string.isRequired,
  valorReajustePaquetes: PropTypes.string.isRequired,
  valorReajusteMax: PropTypes.number.isRequired,
  valorReajusteMaxPQ: PropTypes.number.isRequired,
  comentario: PropTypes.string.isRequired,
  comentarioPQ: PropTypes.string.isRequired,
  checkCentrosAtencion: PropTypes.array.isRequired,
  checkCentrosAtencionPQ: PropTypes.array.isRequired,
  checkTiposPrestacion: PropTypes.array.isRequired,
  checkAranceles: PropTypes.array.isRequired,
  checkVigenciasPaquetes: PropTypes.array.isRequired,
  vigenciasPaquetes: PropTypes.array,
  valorReajusteError: PropTypes.string.isRequired,
  valorReajustePaquetesError: PropTypes.string.isRequired,
  checkCentrosAtencionError: PropTypes.bool.isRequired,
  checkCentrosAtencionErrorPQ: PropTypes.bool.isRequired,
  checkTiposPrestacionError: PropTypes.bool.isRequired,
  checkArancelesError: PropTypes.bool.isRequired,
  checkVigenciasErrorPQ: PropTypes.bool.isRequired,
  periodoReajuste: PropTypes.any.isRequired,
  periodoReajustePQ: PropTypes.any.isRequired,
  // filtros: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  vigenciaReajuste: PropTypes.instanceOf(Date),
  vigenciaReajustePQ: PropTypes.instanceOf(Date),
  inicioVigenciaReajusteError: PropTypes.bool.isRequired,
  inicioVigenciaReajustePQError: PropTypes.bool.isRequired,
  replicaPaquetes: PropTypes.number,
  replicaPaquetesError: PropTypes.bool.isRequired,
  replicaArancel: PropTypes.bool.isRequired,
  replicaArancelError: PropTypes.bool.isRequired,
  ENV: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.solicitudReajuste.loading,
  rutInstitucion: state.global.rutInstitucion,
  tiposArancel: state.global.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.tiposPrestaciones,
  valorReajuste: state.solicitudReajuste.valorReajuste,
  valorReajustePaquetes: state.solicitudReajuste.valorReajustePaquetes,
  valorReajusteMax: state.solicitudReajuste.valorReajusteMax,
  valorReajusteMaxPQ: state.solicitudReajuste.valorReajusteMaxPQ,
  comentario: state.solicitudReajuste.comentario,
  comentarioPQ: state.solicitudReajuste.comentarioPQ,
  checkCentrosAtencion: state.solicitudReajuste.checkCentrosAtencion,
  checkCentrosAtencionPQ: state.solicitudReajuste.checkCentrosAtencionPQ,
  checkTiposPrestacion: state.solicitudReajuste.checkTiposPrestacion,
  checkAranceles: state.solicitudReajuste.checkAranceles,
  valorReajusteError: state.solicitudReajuste.valorReajusteError,
  valorReajustePaquetesError: state.solicitudReajuste.valorReajustePaquetesError,
  checkCentrosAtencionError: state.solicitudReajuste.checkCentrosAtencionError,
  checkCentrosAtencionErrorPQ: state.solicitudReajuste.checkCentrosAtencionErrorPQ,
  checkTiposPrestacionError: state.solicitudReajuste.checkTiposPrestacionError,
  checkArancelesError: state.solicitudReajuste.checkArancelesError,
  vigenciaReajuste: state.solicitudReajuste.vigenciaReajuste,
  vigenciaReajustePQ: state.solicitudReajuste.vigenciaReajustePQ,

  checkVigenciasErrorPQ: state.solicitudReajuste.checkVigenciasErrorPQ,
  checkVigenciasPaquetes: state.solicitudReajuste.checkVigenciasPaquetes,
  vigenciasPaquetes: state.solicitudReajuste.vigenciasPaquetes,

  inicioVigenciaReajusteError: state.solicitudReajuste.inicioVigenciaReajusteError,
  inicioVigenciaReajustePQError: state.solicitudReajuste.inicioVigenciaReajustePQError,

  replicaPaquetes: state.solicitudReajuste.replicaPaquetes,
  replicaPaquetesError: state.solicitudReajuste.replicaPaquetesError,
  replicaArancel: state.solicitudReajuste.replicaArancel,
  replicaArancelError: state.solicitudReajuste.replicaArancelError,

  periodoReajuste: state.filtroBusquedaRA.periodoReajuste,
  periodoReajustePQ: state.filtroBusquedaRA.periodoReajustePQ,

  ENV: state.global.ENV,

  filtros: {
    tipoArancel: state.global.filtros_CAT.tipoArancel,
    centroAtencion: state.global.filtros_CAT.centroAtencion,
    tipoPrestacion: state.global.filtros_CAT.tipoPrestacion,
  },
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(SolicitudReajuste);

